import {SMS} from "../controllers/SMS";

export default class HomePage {
    static instance = null;

    static getInstance() {
        if (HomePage.instance === null) {
            HomePage.instance = new HomePage();
        }
        return HomePage.instance;
    }

    init() {
        if(Electro.DEBUG) {
            console.log('HomePage.init');
        }
        if (!sessionStorage.seenAttentiveForm && !SMS.isUserOptedIn()) {
            SMS.setSMSModalTimer();
        } else {
            if(Electro.DEBUG) {
                console.log('User has already seen the form');
            }
        }

        // Submit new user form
        const newUserForm = document.querySelector('.new-user-form');
        if (newUserForm) {
            $(newUserForm).parsley();
            newUserForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                // Disable the submit button
                newUserForm.querySelector('button[type="submit"]').disabled = true;
                await this.submitNewUserForm(e);

                // Enable back the submit button
                newUserForm.querySelector('button[type="submit"]').disabled = false;
            });
        }

        document.querySelectorAll('.sms-opt-in-form').forEach(form => {
            $(form).parsley();
            form.addEventListener('submit', (e) => {
                e.preventDefault();
                this.submitOptInForm(e);
            });
        });
    }

    async submitNewUserForm(e) {
        const form = e.target;

        if (!$(form).parsley().isValid) {
            console.log('Form is not valid.');
            return;
        }

        const formData = new FormData(e.target);
        const formValues = {};

        // Iterate through the FormData entries
        for (const [name, value] of formData.entries()) {
            formValues[name] = value;
        }

        fetch('/wp-json/clorox-preference-center/v1/newsletter/', {
            method: 'POST',
            headers: {
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formValues),
        })
            .then((result) => result.json())
            .then((json) => {
                if (Electro.DEBUG) {
                    console.info(json);
                }
                if (json.status === 0) {
                    // Success
                    this.displayConfirmation(form);
                } else {
                    if (Electro.DEBUG) {
                        console.error('Error:', json);
                    }
                    form.querySelector('.error-message').textContent = json.message;
                    form.querySelector('.error-message').classList.remove('hidden');
                }
            });

    }

    async submitOptInForm(e) {
        const form = e.target;

        if (!$(form).parsley().isValid) {
            console.log('Form is not valid.');
            return;
        }

        // Check the user data, to update the globals first.
        await this.checkUserData();

        // Send a fetch request
        const formData = new FormData(e.target);
        const formValues = {};

        // Iterate through the FormData entries
        for (const [name, value] of formData.entries()) {
            formValues[name] = value;
        }

        // Is this a recipe form?
        if (form.querySelector('input[name="recipe_id"]')) {
            formValues.recipe = form.querySelector('input[name="recipe_id"]').value;
        }

        fetch('/wp-json/electro/v1/sms/optInUser/', {
            method: 'POST',
            headers: {
                credentials: 'same-origin',
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-WP-Nonce': Electro.wp_rest_nonce,
            },
            body: JSON.stringify(formValues),
        })
            .then(response => response.json())
            .then(data => {
                if (data.status === 0) {
                    if (Electro.DEBUG) {
                        console.log('Success:', data);
                    }
                    this.displayConfirmation(form);
                } else {
                    if (Electro.DEBUG) {
                        console.error('Error:', data);
                    }
                    form.querySelector('.error-message').textContent = data.message;
                    form.querySelector('.error-message').classList.remove('hidden');
                }
            });
    }


    /**
     * This checks the user's SMS opt-in status, against the SMS API.
     *
     * This only runs if the optin status is false.
     */
    checkUserData() {
        // Run conditionals
        if (!SMS.isUserOptedIn()) {
            // Wait for the response, then update the globals for the user
            return new Promise((resolve, reject) => {
                const request = fetch('/wp-json/electro/v1/sms/getUserData/', {
                    method: 'GET',
                    headers: {
                        credentials: 'same-origin',
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': Electro.wp_rest_nonce,
                    },
                });
                request.then(response => response.json())
                    .then(data => {
                        if (data.status !== 0) {
                            reject(data.message);
                        }
                        if (Electro.DEBUG) {
                            console.log('Success:', data);
                        }
                        // Update the globals
                        Electro.SMSOptedIn = data.optedIn === 1;
                        Electro.HasPhoneMobile = data.phoneMobile !== '';
                        resolve(data);
                    }).catch(error => {
                    if (Electro.DEBUG) {
                        console.error('Error:', error);
                    }
                    reject(error);
                });

            });
        }

        // Resolve with no data
        return Promise.resolve();
    }

    displayConfirmation(form) {
        if (Electro.DEBUG) {
            console.info('SmsOptIn.displayConfirmation');
        }
        const container = form.closest('.content-container');
        container.querySelector('.form-container').classList.add('hidden');
        container.querySelector('.form-container').remove();
        container.querySelector('.confirmation').classList.remove('hidden');
    }
}

window.addEventListener('DOMContentLoaded', () => {
    // If not home page, return
    const isHomePage = document.querySelector('body').classList.contains('home');
    if(!isHomePage) return;

    // If the instance already exists, then return
    if(window.Electro.homePage) return;

    // Create the instance and initialize
    window.Electro.homePage = HomePage.getInstance();
    window.Electro.homePage.init();
});

